export default __webpack_public_path__ + "static/media/17t.49ac9bb3.jpg";